<template>
    <div class="thank text-center">
        <b-container>
            <b-row>
                <b-col lg="10" offset-lg="1">
                    <div class="logo">
                        <img class="img-fluid" src="../assets/img/Logo_Peak1.svg" alt="">
                        <img class="img-fluid" src="../assets/img/Logo_ActorsChallenge-2 2blanco.svg" alt="">
                    </div>
                    <h1>¡GRACIAS POR<br> TU COMPRA!</h1>
                    <p class="text">Tu compra ha sido registrada  y en breve te llegará un correo con la información necesaria para acceder a tu curso, en nuestra plataforma. Muchas gracias por tu confianza.</p>
                    <p class="text">Recuerda que comenzamos el 16 de marzo 2026 a las 07:30 pm hora Ciudad de México.</p>
                    <p class="smalltext">Si tienes alguna pregunta no dudes<br> en ponerte en contacto con nosotros en:</p>
                    <a href="mailto:cursos@peakme.com.mx">cursos@peakme.com.mx</a><br>
                    <a href="wa.link/qezkrf">WA: +52 55 1458 8890</a>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        mounted () {
            const params = new URLSearchParams(window.location.search)
            var value = Number(params.get('amount'))
            const currency = 'USD'
            console.log(value)
            // Validación mínima
            if (!value || !currency) {
                value = '0.0'
            }

            // Evitar duplicados
            if (!localStorage.getItem('purchase_tracked')) {
                if (window.fbq) {
                    window.fbq('track', 'Purchase', {
                    value: value,
                    currency: currency
                    })
                    localStorage.setItem('purchase_tracked', true)
                }
            
            }
        }
    }
</script>

<style scoped>
.thank{
    min-height: 100vh;
    background: #000;
    color: #fff;
    padding: 3% 10%;
    background-image: url('../assets/img/Vector6.svg'), url('../assets/img/Vector7.svg');
    background-position: right 30px, left bottom;
    background-repeat: no-repeat, no-repeat;
}
h1{
    font-family: 'AkiraExpanded';
    font-size: 50px;
    margin-bottom: 40px;
}
.logo{
    margin-bottom: 40px;
}
p{
    font-size: 25px;
}
.text{
    margin-bottom: 40px;
}
.smalltext{
    font-size: 18px;
    margin-bottom: 30px;
}
a{
    font-weight: 500;
    font-size: 18px;
    color: #2CFAC3;
}
@media (max-width: 1150px) {
    .thank{
        background-size: 170px, 170px;
    }
}
@media (max-width: 768px) {
    h1{
        font-size: 40px;
    }
    p{
        font-size: 20px;
    }
    .text{
        margin-bottom: 40px;
    }
    .smalltext{
        font-size: 18px;
    }
    a{
        font-size: 18px;
    }
}
@media (max-width: 668px) {
    .thank{
        padding-top: 70px;
        background-image: none;
    }
    .logo img{
        max-width: 45%;
    }
    h1{
        font-size: 40px;
    }
    p{
        font-size: 20px;
    }
    .text{
        margin-bottom: 40px;
    }
    .smalltext{
        font-size: 18px;
    }
    a{
        font-size: 18px;
    }
}
@media (max-width: 576px) {
    h1{
        font-size: 30px;
        margin-bottom: 30px;
    }
    p{
        font-size: 18px;
    }
    .text{
        margin-bottom: 30px;
    }
    .smalltext{
        font-size: 15px;
    }
    a{
        font-size: 15px;
    }
}
</style>